module.exports = __webpack_public_path__ + "54cf98f5/img/placeholder.888fcd0b.svg";